import React from "react";

const BioField = ({ bio, onChange, t }) => (
  <div>
    <label className="block text-xs font-semibold uppercase tracking-wide text-slate-400 mb-2">
      {t("Bio")}
    </label>
    <input
      required
      placeholder={t("Bio")}
      className="w-full rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-transparent transition"
      value={bio}
      onChange={(event) => onChange(event.target.value)}
    ></input>
  </div>
);

export default BioField;
